const PREFIX = 'rc'
const TOKEN = '1058bc8be52d20f1ffab209e0264ab'
const API_URL = `https://cms.krewinkel.nl/api/collections/get/${PREFIX}_articles?token=${TOKEN}&filter[publish]=true`
const NEWS_URL = `https://cms.krewinkel.nl/api/collections/get/${PREFIX}_news?token=${TOKEN}&filter[publish]=true`

export const config = {
    API_URL,
    NEWS_URL,
    TOKEN,
    PREFIX
}
